import { useCallback } from 'react'
import { useMutation, useApolloClient } from '@apollo/client/react'
import { tokenStore } from '@/lib/auth/tokenStore'
import { routes } from '@/shared/constants'
import { LOGOUT } from '../api/mutations'

/**
 * Cierra la sesión real: invalida la cookie de refresh en el gateway, limpia
 * el access token en memoria y vacía el cache de Apollo.
 */
export function useLogout() {
  const client = useApolloClient()
  const [logoutMutation, { loading }] = useMutation(LOGOUT, {
    context: { skipAuth: false },
  })

  const logout = useCallback(async () => {
    try {
      await logoutMutation()
    } catch {
      // Si el logout falla (ej. token ya expirado), igual limpiamos localmente.
    } finally {
      tokenStore.clear()
      await client.clearStore()
      window.location.assign(routes.public.login)
    }
  }, [logoutMutation, client])

  return { logout, loading }
}
